import {QueryUserByIds} from "@/components/selectUserCtl/servers/userSelServer";
import {GoingNewUtils} from "xmgoing-utils";
import {AccountFactory} from "@/main-page/utils/AccountFactory";

/**
 * 获取id集合
 * @param cellContent
 */
export function getIdsAry(cellContent){
  let ids:any = cellContent;
  if((ids+'').indexOf("[")>=0){
    try{
      eval(' window.idsAry = '+ids);
      ids=(window as any).idsAry;
    }catch (e){
      console.error(e,"====xmUserSelectCell===转换失败")
    }
  }else{
    if (typeof (ids) === 'string') {
      if(ids.indexOf(",")>=0){
        ids = (ids+'').split(",");
      }else{
        ids = (ids+'').split(";");
      }
    }
  }
  return ids;
}

/**
 * 将重复的id去掉
 * @param userIdsAry
 */
export function getNewIds(userIdsAry){
  const newIds=[];
  if(userIdsAry&&Array.isArray(userIdsAry)&&userIdsAry.length>0){
    userIdsAry.forEach((idProp)=>{
      if(newIds.findIndex((propOldId)=>{
        return propOldId===idProp;
      })<0){
        newIds.push(idProp);
      }
    })
  }
  return newIds;
}
export class UsersFactory extends AccountFactory{
  userIdsAry:any;
  userLoading:boolean;
  addUserMapQueue:any;
  userLabelMap:any;

  constructor() {
    super();
    this.userIdsAry=[];
    this.addUserMapQueue={};
    this.userLoading=false;
    this.userLabelMap={};
  }

  /**
   * 用户id 翻译成中文 的处理
   */
  addUserIds(ids){
    if (typeof (ids) === 'string') {
      ids = getIdsAry(ids);
    }
    if(Array.isArray(ids)){
      this.userIdsAry=[...this.userIdsAry,...ids];
    }
  }

  loadingAllUsers(){
    this.userLoading=true;

    this.userIdsAry =getNewIds(this.userIdsAry);
    if(this.userIdsAry.length>0){
      QueryUserByIds({ids:this.userIdsAry.join(";")}, (res) => {
        this.userIdsAry=[];
        this.userLoading=false;
        //设置userMap
        if(res&&res.records){
          res.records.forEach((userObj)=>{
            this.userLabelMap[userObj.id]=userObj;
          })
        }
        Object.keys(this.addUserMapQueue).forEach((propIds)=>{
          const flushMapFlag=this.addUserMapQueue[propIds];
          flushMapFlag.value=GoingNewUtils.getUUChar(32);
        })
      })
    }
  }

  getLabelById(userId){

    return this.userLabelMap[userId]
  }
  /**
   * 获取用户映射信息
   * @param ids
   * @param selUserRecords
   */
  getUserLabels(selUserRecords){
    this.addUserMapQueue[GoingNewUtils.getUUChar(32)]=selUserRecords;
    if(this.userIdsAry.length>0&&this.userLoading===false){
      this.loadingAllUsers();
    }
  }

}
